// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import store from './pathify/store'
import router from './router'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
import axios from 'axios'
import VueAxios from 'vue-axios'
import moment from 'moment'
import momentTimezone from 'moment-timezone'
import VueSocketio from 'vue-socket.io'
import VueSweetalert2 from 'vue-sweetalert2'
import VueSessionStorage from 'vue-sessionstorage'

Vue.use(VueSessionStorage)
Vue.use(Vuetify)
Vue.use(VueAxios, axios)
Vue.use(moment)
Vue.use(momentTimezone)
Vue.use(VueSweetalert2)
Vue.use(VueSocketio, process.env.APIsocket)

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js